"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useUnmount(fn, dependencies) {
    var ref = react_1.useRef(function () {
        throw new Error('Cannot call an event handler while rendering.');
    });
    react_1.useEffect(function () {
        ref.current = fn;
    }, __spreadArray([fn], dependencies));
    react_1.useEffect(function () { return function () { return ref.current(); }; }, []);
}
exports.default = useUnmount;
//# sourceMappingURL=useUnmount.js.map